import { Grid } from '@mui/material';
import React, { useMemo } from 'react';
import { cardStyle } from 'views/OrderNewProductOrService/OrderNewProductOrService';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { selectIsEligible } from 'selectors/partnerStatusSelector';
import { Features } from 'reducers/partnerStatusReducer';
import { FeatureEligibility } from 'pco-product-service-internal-consumer';
import CardBodyComponent from '../common/card/CardBodyComponent';
import CardHeaderComponent from '../common/card/CardHeaderComponent';
import CardTooltipButton from '../common/card/CardTooltipButton';

interface SubscriptionManagementProps {
  partnerId?: string;
}

const SubscriptionManagement = ({ partnerId }: SubscriptionManagementProps) => {
  const navigate = useNavigate();
  const isEligibleForMSStore = useSelector(selectIsEligible) as
    | (FeatureEligibility[] & { message?: string; messages?: string[] })
    | undefined;

  const initiateSubscriptionManagement = () => {
    if (partnerId) {
      navigate(`/partner/${partnerId}/subscriptionManagment`);
    }
  };

  const isEligibleForMS = useMemo<FeatureEligibility | undefined>(() => {
    if (isEligibleForMSStore?.message) return undefined;
    return (
      isEligibleForMSStore?.find((eligibility) => eligibility.feature === Features.MANAGE_SUBSCRIPTIONS) ?? undefined
    );
  }, [isEligibleForMSStore]);

  const title = useMemo<React.ReactNode>(() => {
    if (isEligibleForMSStore?.messages) {
      const messages = isEligibleForMSStore.messages;
      return (
        <>
          <div>{partnerId ? 'Partner' : 'Business relation '} is missing following data:</div>
          {messages.map((message, index) => (
            <div key={index}>{message}</div>
          ))}
        </>
      );
    }
    return `${partnerId ? 'Partner' : 'Business relation'}  is not eligible for Subscription Management`;
  }, [isEligibleForMSStore, partnerId]);

  return (
    <Grid data-testid="subscription-management" item sx={cardStyle}>
      <CardHeaderComponent title={'Subscription management'} />
      <CardBodyComponent content={'Create or manage subscriptions to research material for a partner.'} />
      <CardTooltipButton
        id={'subscription-management-button'}
        data-testid={'subscription-management-button'}
        buttonText={'Manage subscriptions'}
        isEligible={isEligibleForMS?.isEligible ?? false}
        handleClick={initiateSubscriptionManagement}
        tooltipTitle={title}
      />
    </Grid>
  );
};

export default SubscriptionManagement;
